<template>
  <el-popover placement="top" trigger="hover">
    <div class="activity-box">
      <div class="title">{{ title }}</div>
      <div class="body">
        <div v-if="activityName">{{ activityName }}</div>
        <div class="org-text" v-if="subsidyCommission * 1"><span v-if="subsidyIncomes > 0">+</span>{{ subsidyCommission || 0 }}%</div>
        <div class="org-text"><span v-if="subsidyIncomes > 0">+</span>{{ subsidyIncomes || '0.00' }}</div>
      </div>
    </div>
    <span slot="reference" class="wenhao">?</span>
  </el-popover>
</template>

<script>
export default {
  props: ['activityName', 'subsidyCommission', 'subsidyIncomes'],
  props: {
    title: {
      default: '活动奖励：'
    },
    activityName: null,
    subsidyCommission: null,
    subsidyIncomes: null
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.wenhao {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: #fff;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 15px;
  font-size: 14px;
  cursor: pointer;
}
.el-popover {
  .activity-box {
    height: auto;
    width: 200px;
    .title {
      font-size: 14px;
      color: #333;
      margin-bottom: 8px;
    }
    .body {
      font-size: 12px;
      color: #666;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .org-text {
        color: $baseColor;
      }
    }
  }
}
</style>